import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router";

// eslint-disable-next-line react/prop-types
const Footer = ({isFromSchoolAdminBasicInfo}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/login", { state: { isSignInClicked: true } });
  }
  
  return (
    <Box sx={{ width: 1, textAlign: 'center' }}>
      {
        !isFromSchoolAdminBasicInfo && 
      <Typography sx={{fontSize:'16px',color:'white'}}>
        Already have an account?{" "}
        <Link onClick={()=>handleClick()} underline="always" sx={{fontSize:'18px',color:'white',textDecorationColor:'white', cursor:'pointer'}}>
          Sign in
        </Link>
      </Typography>
      }
    </Box>
  );
};

export default Footer;
